import { render } from "./TextViewer.vue?vue&type=template&id=2068b4b3&scoped=true"
import script from "./TextViewer.vue?vue&type=script&lang=js"
export * from "./TextViewer.vue?vue&type=script&lang=js"

import "./TextViewer.vue?vue&type=style&index=0&id=2068b4b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2068b4b3"]])

export default __exports__